/**
 * IconCircle — pill-shaped container for the four locked Callout icons (Tip,
 * Watch Out, Remember, Key Insight). Per `/shared/design-tokens.v2.json`
 * `callout.*` block + `radius.pill`.
 *
 * The bg / border colors come from the callout token block so per-tenant theme
 * overrides apply automatically.
 */

export default function IconCircle({
  children,
  bg = "var(--ppr-color-accent-navy)",
  border = "var(--ppr-color-accent-navy)",
  size = 38,
}) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "var(--ppr-radius-pill)",
        background: bg,
        border: `2px solid ${border}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
      data-component="IconCircle"
    >
      {children}
    </div>
  );
}
